import { SITE } from "@/constants/site";
import conseils from "./conseils-es";

/* Versión española — traducida del contenido de referencia en francés. */
const es = {
    nav: {
        approche: "Enfoque",
        soins: "Tratamientos",
        tarifs: "Tarifas",
        cabinet: "Clínica",
        medecin: "Doctora",
        faq: "Preguntas",
        conseils: "Consejos",
        rdvShort: "Reservar",
        rdvLong: "Pedir cita",
        langAria: "Elegir idioma",
    },
    common: {
        rdvOn: "Pedir cita en",
        viewMaps: "Ver en Google Maps",
        readMore: "Saber más",
        home: "Inicio",
        breadcrumbAria: "Ruta de navegación",
        hoursTitle: "Horario de apertura",
        faqTitle: "Preguntas frecuentes",
        rdvTitle: "Pedir cita",
        conseilsLink: "Leer los consejos antes y después",
        closed: "Cerrado",
    },
    beforeAfter: {
        before: "Antes",
        after: "Después",
        compare: "Comparar antes y después:",
    },
    hours: {
        days: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
        range: "10:30 – 17:30",
        compactStrong: "Lunes, martes, jueves y viernes",
        compactRest: "de 10:30 a 17:30 — cerrado miércoles, sábado y domingo.",
    },
    hero: {
        eyebrow: "Dra. Souhali · Médica · Asnières-sur-Seine",
        h1: "Tus hormonas, tu piel, tu cabello. Un solo seguimiento.",
        sub: "Tu consulta de medicina estética en Asnières-sur-Seine, cerca de París.",
        specialites:
            "Medicina estética · antiedad · depilación láser y electrólisis · inyecciones de ácido hialurónico · skinboosters · inductores de colágeno · peelings · microneedling · acné · melasma · salud íntima",
        cta: "Pedir cita",
        link: "Ver los tratamientos",
        doctolibMention: "Cita en línea en",
        photoAlt:
            "La recepción de la clínica: pared terracota, medallón dorado Aurassium y sofá crema",
    },
    approche: {
        eyebrow: "El enfoque",
        h2: "Cuando las hormonas se ven en la piel",
        lead: "Antes de tratar lo que se ve, entendemos de dónde viene.",
        paragraphes: [
            "La Dra. Souhali Massilia, médica de familia con formación en medicina estética, medicina antiedad y salud de la mujer, te recibe para una atención integral.",
            "Tratamos los efectos visibles de los trastornos hormonales (SOP, menopausia): acné, caída del cabello, vello excesivo. El hirsutismo se trata en la consulta con láser y electrólisis.",
            "También cuidamos tu salud íntima, en particular la sequedad vaginal.",
            "Ofrecemos depilación láser, inyecciones de ácido hialurónico, skinboosters, inductores de colágeno, peelings y microneedling.",
        ],
        conclusion:
            "Un enfoque que combina rigor médico con acompañamiento y seguimiento personalizados.",
        prompt: "¿Te reconoces?",
        items: [
            ["SOP", "Acné, vello que aparece donde antes no había (hirsutismo), caída del cabello, ciclos irregulares."],
            ["Perimenopausia y menopausia", "Piel más fina y más seca, pérdida de firmeza, incomodidad íntima."],
            ["Endometriosis", "Los efectos de tu tratamiento hormonal sobre la piel y el cabello."],
            ["Trastornos androgénicos", "Vello en la cara y el cuerpo, acné, cabello que pierde densidad."],
            ["Tras un cambio de peso", "Calidad de la piel y flacidez después de ganar o perder peso."],
            ["Una atención integral", "Una sola médica observa tu terreno hormonal, tu piel y tu cabello."],
        ],
    },
    parcours: {
        eyebrow: "El recorrido",
        h2: "Cómo funciona",
        lead: "Tres pasos sencillos: hablamos, exploramos y decidimos juntas. Nada se decide antes de la consulta.",
        photoAlt:
            "Una encimera blanca bajo cinco láminas anatómicas floreadas: cerebro, rostro, pulmones, corazón",
        photoLegend: "El puesto de análisis de la piel, bajo las láminas anatómicas",
        steps: [
            ["La consulta", "hablamos de tus síntomas, de tu historia y de lo que te molesta."],
            ["El estudio", "si hace falta, la médica prescribe un estudio hormonal y las pruebas útiles."],
            ["El plan", "seguimiento médico, tratamientos de piel, cabello o vello. Lo elegimos juntas."],
        ],
    },
    soinsSection: {
        eyebrow: "Nuestros servicios",
        h2: "Los tratamientos",
        lead: "Seguimiento hormonal y medicina estética en el mismo lugar. Cada acto lo realiza o lo supervisa una médica.",
        photoAlt: "La sala de tratamientos: camilla, láser y grandes ventanales",
        photoLegend: "La sala de tratamientos",
        familles: [
            ["Seguimiento hormonal", ["consulta de SOP y trastornos hormonales", "perimenopausia y menopausia", "valoración de los signos hormonales"], "sopk"],
            ["Depilación láser y electrólisis", ["vello asociado al SOP e hirsutismo", "cara y cuerpo", "electrólisis para el vello claro", "sesiones por zona o varias zonas"], "epilation-laser"],
            ["Cabello", ["estudio de la caída del cabello", "mesoterapia del cuero cabelludo"], "chute-de-cheveux"],
            ["Calidad de la piel", ["peeling superficial y medio", "mesoterapia", "microneedling", "skinbooster", "melasma y manchas"], "peau-et-rides"],
            ["Arrugas y flacidez", ["inyecciones de ácido hialurónico", "inductores de colágeno", "hilos inductores de colágeno"], "acide-hyaluronique"],
            ["Salud íntima", ["sequedad de la zona íntima", "atrofia de la zona íntima"], "sante-intime"],
        ],
        detailTitle: "En detalle, motivo por motivo",
        illustrations: {
            eyebrow: "Ilustraciones médicas",
            h3: "Lo que buscamos conseguir",
            lead: "Tres motivos de consulta frecuentes. Desliza el cursor para comparar el antes y el después.",
            items: {
                levres: {
                    title: "Labios — ácido hialurónico",
                    note: "Hidratación y definición del contorno en una sesión. Volumen medido, nunca rígido.",
                    beforeAlt: "Ilustración: labios finos, contorno poco definido, antes de la inyección",
                    afterAlt: "Ilustración: labios hidratados con el contorno redefinido, tras la inyección de ácido hialurónico",
                },
                melasma: {
                    title: "Melasma — manchas pigmentarias",
                    note: "Protocolo despigmentante, peelings y fotoprotección durante varios meses.",
                    beforeAlt: "Ilustración: manchas marrones de melasma en pómulos y frente",
                    afterAlt: "Ilustración: tono uniforme tras el tratamiento del melasma",
                },
                cheveux: {
                    title: "Caída del cabello — densidad",
                    note: "Estudio de la causa y, después, mesoterapia del cuero cabelludo y tratamiento de fondo.",
                    beforeAlt: "Ilustración: raya ensanchada y cuero cabelludo visible, caída del cabello",
                    afterAlt: "Ilustración: densidad capilar recuperada, raya más estrecha",
                },
            },
            disclaimer:
                "Imágenes ilustrativas con fines pedagógicos. No representan a pacientes de la clínica y no constituyen una promesa de resultado.",
        },
        footnote:
            "Los resultados varían de una persona a otra. Todo se te explica antes de empezar. Para los actos estéticos se entrega un presupuesto por escrito y se respeta un plazo de reflexión.",
    },
    tarifsSection: {
        eyebrow: "Con total transparencia",
        h2: "Las tarifas",
        lead: "Precios claros, comunicados antes de empezar. Para cualquier acto estético se entrega un presupuesto por escrito, explicado y decidido contigo.",
        apercuTitle: "Los tratamientos, en resumen",
        apercu: [
            ["Depilación láser", "desde 30 € por zona"],
            ["Peelings y microneedling", "de 120 € a 200 €"],
            ["Mesoterapia, cabello y piel", "desde 150 €"],
            ["Ácido hialurónico", "desde 350 € la jeringa"],
            ["Inductores de colágeno", "desde 400 €"],
            ["Salud íntima", "desde 350 €"],
        ],
        detailLink: "Ver el detalle de las tarifas",
        note: "Los actos de medicina estética no están cubiertos por la seguridad social francesa. Se respeta un plazo de reflexión antes de cualquier acto.",
    },
    lieu: {
        eyebrow: "El lugar",
        h2: "El lugar",
        lead: "Una consulta tranquila en Asnières-sur-Seine, luminosa y acogedora, pensada para que estés cómoda.",
        photos: [
            ["cafe.jpg", "El rincón del café, con una estantería en arco terracota y un olivo", "El rincón del café"],
            ["peau.jpg", "Un olivo y dos cuadros terracota en la pared", "El rincón del olivo"],
            ["bureau.jpg", "Una cabina de tratamientos con su camilla, sus equipos y los diplomas de la médica enmarcados", "La cabina de tratamientos"],
        ],
        detailLink: "Ver la clínica y cómo llegar",
    },
    medecinSection: {
        eyebrow: "La doctora",
        h2: "Dra. Souhali Massilia",
        lead: "Médica fundadora de Aurassium Clinic.",
        photoAlt: "Retrato de la Dra. Souhali Massilia, médica, con uniforme médico",
        formationButton: "Formación y titulaciones",
        rpps: `N.º RPPS ${SITE.rpps}`,
        detailLink: "Ver la trayectoria completa",
    },
    formation: {
        dialogTitle: "Formación",
        subtitle: `${SITE.doctor}, médica titulada por el Estado · N.º RPPS ${SITE.rpps}`,
        closeLabel: "Cerrar",
        diplomesTitle: "Títulos nacionales y universitarios",
        autresTitle: "Otras formaciones",
        diplomes: [
            ["2025", "Diploma universitario en técnicas de inyección y relleno", "Universidad Paris-Est Créteil Val-de-Marne (UPEC)"],
            ["2024", "Diploma universitario en medicina estética", "Universidad Paris-Sud (Paris 11)"],
            ["2022", "Capacitación en medicina geriátrica", "Universidad de la Sorbona, Facultad de Medicina (Paris VI)"],
        ],
        autres: [
            ["2025", "Formación en oculoplastia estética", "UPEC"],
            ["2024", "Colegio internacional de medicina estética", "París"],
        ],
        expertises: [
            "Trastornos hormonales femeninos",
            "Medicina estética",
            "Depilación láser",
            "Salud de la piel y del cabello",
        ],
    },
    faq: {
        eyebrow: "Preguntas frecuentes",
        h2: "Lo que más preguntan las pacientes",
        lead: "Las respuestas a las preguntas que surgen antes de una primera cita.",
        items: [
            [
                "¿Qué es el SOP?",
                "El síndrome de ovario poliquístico es un desequilibrio hormonal frecuente. Suele manifestarse con ciclos irregulares, acné, vello excesivo o caída del cabello. El diagnóstico se basa en una entrevista, una exploración clínica y un estudio hormonal.",
            ],
            [
                "¿Cómo saber si mi piel o mi cabello reaccionan a un trastorno hormonal?",
                "Acné que persiste en la edad adulta, vello facial, cabello que se afina en la parte superior de la cabeza o manchas marrones que reaparecen: son signos que merecen un estudio. La consulta busca la causa antes de tratar el signo.",
            ],
            [
                "¿Cómo es la primera consulta?",
                "Se desarrolla en tres tiempos: hablamos de tus signos y de tu historia, la médica explora la piel, el cabello y el vello, y después decidís juntas el plan. Nada se decide ni se realiza antes de esa conversación.",
            ],
            [
                "¿Hace falta un volante de mi médico de cabecera?",
                "No. La cita se pide directamente en línea en Doctolib. Trae tus últimos análisis de sangre si los tienes, así como la lista de tus tratamientos.",
            ],
            [
                "¿Qué tratamientos se ofrecen en la clínica?",
                "Seguimiento del SOP y de los trastornos hormonales, perimenopausia y menopausia, estudio de la caída del cabello, depilación láser y electrólisis de cara y cuerpo, calidad de la piel (peeling, mesoterapia, microneedling, skinbooster), tratamiento del melasma, inyecciones de ácido hialurónico, inductores de colágeno y salud íntima.",
            ],
            [
                "Hirsutismo: ¿láser o electrólisis?",
                "Ambos se practican en la clínica, a menudo de forma complementaria. El láser trata con eficacia el vello oscuro en zonas amplias; la electrólisis toma el relevo en el vello claro, blanco o resistente, pelo a pelo. La elección se hace tras explorar la zona y el tipo de vello.",
            ],
            [
                "¿Qué ofrecéis para la sequedad íntima?",
                "La sequedad y la incomodidad íntimas son frecuentes en la menopausia o bajo tratamiento hormonal. La consulta valora la situación y propone una atención médica adaptada, que puede completarse con un tratamiento en la clínica.",
            ],
            [
                "¿Los actos de medicina estética están cubiertos?",
                "No, los actos de medicina estética no están cubiertos por la seguridad social francesa. Se entrega un presupuesto y se respeta un plazo de reflexión antes de cualquier acto.",
            ],
            [
                "¿Dónde está la clínica?",
                "En 10 rue Vladimir Kramnik, 92600 Asnières-sur-Seine, cerca de Clichy, Bois-Colombes, Courbevoie y Levallois-Perret.",
            ],
        ],
    },
    rdv: {
        eyebrow: "Citas",
        h2: "Pedir cita",
        lead: "En línea, en Doctolib. Para una primera cita, elige «primera consulta».",
        onlineTitle: "En línea",
        onlineText: "A nombre de la Dra. Souhali, en Asnières-sur-Seine.",
        addressTitle: "Dirección",
    },
    footer: {
        doctorLine: `© 2026 ${SITE.name} · ${SITE.doctor}, médica`,
        rpps: `N.º RPPS ${SITE.rpps}`,
        legal: "Aviso legal (en francés)",
        privacy: "Privacidad (en francés)",
        instagramAria: "Instagram de Aurassium Clinic",
    },
    tarifsData: {
        consultations: [
            ["Consulta", "60 €", "Primera cita o seguimiento"],
            ["Consulta SOP", "70 €", "Estudio hormonal completo"],
        ],
        soinsA: [
            ["Calidad de la piel", [
                ["Peeling superficial", "150 €"],
                ["Peeling medio", "200 €"],
                ["Mesoterapia", "150 €"],
                ["Microneedling", "120 €"],
                ["Skinbooster", "300 € (la sesión)"],
            ]],
            ["Cabello", [["Mesoterapia del cuero cabelludo, la sesión", "desde 150 €"]]],
        ],
        soinsB: [
            ["Arrugas y flacidez", [
                ["Ácido hialurónico, la jeringa", "desde 350 €"],
                ["Inductores de colágeno, la sesión", "desde 400 €"],
                ["Hilos inductores de colágeno", "desde 500 €"],
            ]],
            ["Salud íntima", [
                ["Sequedad de la zona íntima, la sesión", "350 €"],
                ["Atrofia de la zona íntima", "según presupuesto"],
            ]],
        ],
        laser: [
            ["Una sola zona", [
                ["Entrecejo", "30 €"],
                ["Labio superior", "40 €"],
                ["Axilas", "50 €"],
                ["Areolas", "50 €"],
                ["Manos", "30 €"],
                ["Antebrazos y manos", "80 €"],
                ["Brazos completos", "150 €"],
                ["Ingles clásicas", "80 €"],
                ["Ingles amplias", "100 €"],
                ["Ingles brasileñas", "120 €"],
                ["Ingles completas", "150 €"],
                ["Surco interglúteo", "50 €"],
                ["Medias piernas, rodillas incluidas", "110 €"],
                ["Muslos", "120 €"],
            ]],
            ["Varias zonas", [
                ["Axilas + antebrazos", "150 €"],
                ["Axilas + medias piernas", "150 €"],
                ["Axilas + medias piernas + antebrazos", "200 €"],
                ["Axilas + piernas completas", "300 €"],
                ["Ingles clásicas + medias piernas + axilas", "220 €"],
                ["Ingles amplias + medias piernas + axilas", "240 €"],
                ["Ingles brasileñas + medias piernas + axilas", "260 €"],
                ["Ingles completas + medias piernas + axilas", "280 €"],
                ["Suplemento surco interglúteo", "40 €"],
            ]],
        ],
    },
    pages: {
        conseils,
        tarifs: {
            eyebrow: "Con total transparencia",
            h1: "Tarifas de consultas y tratamientos",
            lead: "Precios claros, comunicados antes de empezar. Para cualquier acto de medicina estética se entrega un presupuesto por escrito, explicado y decidido contigo, con un plazo de reflexión.",
            consultationsTitle: "Consultas",
            consultationsNote:
                "La consulta es el paso previo a cualquier tratamiento: permite establecer el diagnóstico, comprobar las contraindicaciones y construir el plan de atención.",
            soinsTitle: "Tratamientos de medicina estética",
            laserTitle: "Depilación láser, por zona",
            laserNote:
                "Precio por sesión. El número de sesiones depende de la zona, de la densidad y del color del vello: se estima durante la consulta y nunca se promete de antemano.",
            note: "Los actos de medicina estética no están cubiertos por la seguridad social francesa. Las consultas médicas se rigen por las condiciones habituales de cobertura. Las tarifas pueden variar: prevalecen las comunicadas en consulta.",
        },
        medecin: {
            eyebrow: "La doctora",
            h1: "Dra. Souhali Massilia",
            lead: "Médica fundadora de Aurassium Clinic, en Asnières-sur-Seine.",
            photoAlt: "Retrato de la Dra. Souhali Massilia, médica fundadora de Aurassium Clinic",
            rpps: `N.º RPPS ${SITE.rpps} · colegiada en el Consejo departamental de la Orden de Médicos de Hauts-de-Seine`,
            approcheTitle: "Su enfoque",
            approche: [
                "Medicina general, medicina estética, medicina antiedad y salud de la mujer: esta combinación de formaciones permite mirar un mismo signo desde varios ángulos. Un acné que resiste, un vello que se instala o un cabello que se afina no se tratan como problemas aislados, sino en relación con un terreno hormonal que se explora primero.",
                "Cada atención comienza con una entrevista y una exploración clínica, seguidas si es necesario de un estudio. Después se exponen las opciones con sus límites: lo que un tratamiento puede aportar razonablemente, en cuánto tiempo y lo que no va a hacer. Los actos los realiza o los supervisa la médica.",
            ],
            jobTitle:
                "Médica de familia — medicina estética, antiedad y salud de la mujer",
            ctaTitle: "Consultar con la Dra. Souhali",
            ctaText: `En la clínica, ${SITE.address}. Para una primera cita, elige «primera consulta».`,
        },
        cabinet: {
            eyebrow: "El lugar",
            h1: "La clínica, en Asnières-sur-Seine",
            lead: "Una consulta tranquila, luminosa y acogedora, pensada para que estés cómoda desde la entrada. Las consultas y los tratamientos se realizan en el mismo lugar, en un espacio dedicado.",
            photos: [
                ["accueil.jpg", "La recepción de la clínica, con su pared terracota y su medallón dorado", "La recepción", "50% 50%"],
                ["cafe.jpg", "El rincón del café, con una estantería en arco terracota y un olivo", "El rincón del café", "50% 50%"],
                ["peau.jpg", "Un olivo y dos cuadros terracota en la pared", "El rincón del olivo", "50% 50%"],
                ["bureau.jpg", "Una cabina de tratamientos con su camilla y los diplomas de la médica enmarcados", "La cabina de tratamientos", "50% 45%"],
                ["salle.jpg", "La sala equipada para la depilación láser", "La sala de láser", "50% 50%"],
                ["mur.jpg", "Pared de la clínica, ambiente cálido y luminoso", "El ambiente", "50% 50%"],
            ],
            surPlaceTitle: "Lo que encontrarás en la clínica",
            surPlace: [
                "La clínica se organiza en torno a tres espacios. Primero la recepción, con su pared terracota: es donde te recibimos y donde esperas, rara vez mucho tiempo, porque las citas se espacian para evitar esperas. Hay un rincón del café a tu disposición, con un lugar cómodo donde sentarte.",
                "Después la consulta, donde tienen lugar la entrevista y la exploración clínica. Es la sala en la que nos tomamos el tiempo: tu historia, tus tratamientos, tus análisis, lo que te molesta en el día a día. Nada se decide ni se realiza antes de esa conversación.",
                "Por último la sala de tratamientos, equipada para los actos que se realizan en la clínica: depilación láser y electrólisis, peelings, mesoterapia, microneedling, inyecciones. El material es de uso médico y la higiene sigue las normas de una consulta médica, con material de un solo uso en todo lo que lo requiere.",
            ],
            derouleTitle: "Cómo transcurre una visita",
            deroule: [
                "Una primera visita siempre empieza por una consulta. Sirve para entender de dónde viene lo que te trae — un desequilibrio hormonal, una piel que reacciona, un vello que se instala — antes de plantear ningún gesto. Al final de esa cita puede prescribirse un estudio analítico.",
                "Cuando se plantea un acto estético, nunca se realiza en el momento: se entrega un presupuesto por escrito, se explica y se respeta un plazo de reflexión. Te vas con la información necesaria para decidir en casa, sin presión.",
                "Las sesiones siguientes son más cortas y se centran en el tratamiento acordado. Se propone una cita de control para valorar el resultado y ajustar lo que viene después. En los tratamientos que se valoran a lo largo del tiempo — cabello, melasma, calidad de la piel — se toman fotografías en la clínica, con las mismas condiciones de luz, para comparar de forma objetiva.",
            ],
            preparerTitle: "Preparar tu visita",
            preparerLead:
                "Algunas precauciones sencillas permiten aprovechar mejor la cita:",
            preparerItems: [
                "trae tus últimos análisis de sangre y la lista de tus tratamientos, anticoncepción incluida",
                "anota tus preguntas antes de venir: las repasamos una a una",
                "para una sesión de depilación láser, rasura la zona el día antes y evita la cera y las pinzas en las semanas previas",
                "evita la exposición solar y los autobronceadores antes de un láser o un peeling, y protege la zona después",
                "ven sin maquillaje si está previsto un tratamiento facial",
                "informa de cualquier embarazo, lactancia o tratamiento en curso: algunos actos se aplazan o están contraindicados",
            ],
            preparerFin:
                "Puedes venir acompañada. Si necesitas anular o cambiar la cita, hazlo en Doctolib cuanto antes: el hueco se ofrecerá a otra paciente.",
            soinsTitle: "Los tratamientos que se realizan en la clínica",
            soinsLead:
                "La consulta de Asnières-sur-Seine reúne dos actividades complementarias: la salud de la mujer, con los trastornos hormonales y sus efectos visibles sobre la piel, el cabello y el vello, y la medicina estética, que corrige esos efectos una vez comprendida la causa. Los motivos de consulta más frecuentes son los siguientes:",
            soinsItems: {
                "epilation-laser": "vello facial y corporal, hirsutismo",
                "acide-hyaluronique": "labios, ojeras, volúmenes faciales",
                "peau-et-rides": "skinboosters, inductores de colágeno, peelings, microneedling",
                melasma: "protocolos despigmentantes y fotoprotección",
                acne: "atención médica y secuelas",
                "chute-de-cheveux": "estudio, mesoterapia del cuero cabelludo",
                "sante-intime": "sequedad e incomodidad íntimas",
                sopk: "repercusión en la piel y el vello",
                menopause: "piel, cabello, confort íntimo",
            },
            soinsFin:
                "Todos estos tratamientos se realizan en la clínica, por la misma médica, desde la primera entrevista hasta la cita de control. Ningún acto se delega y ninguno se propone sin indicación médica.",
            cadreTitle: "Una consulta médica, no un centro de estética",
            cadre: [
                "Aurassium Clinic es una consulta médica dirigida por la Dra. Souhali Massilia, médica colegiada en la Orden de Médicos francesa. Lo que compartes en consulta está protegido por el secreto médico, y la historia creada durante tu visita solo se consulta en el marco de tu seguimiento.",
                "En la práctica, esto cambia tres cosas. Los productos utilizados son productos sanitarios, trazados por número de lote. Las contraindicaciones se buscan de forma sistemática antes de un acto: embarazo, lactancia, tratamiento fotosensibilizante, antecedentes de cicatrices, fototipo. Y una solicitud puede rechazarse o aplazarse cuando no se reúne la indicación: una entrevista nunca obliga a un tratamiento.",
                "La clínica no atiende urgencias. En caso de urgencia médica, llama al 15 o al 112, o acude al servicio de urgencias más cercano.",
            ],
            adresseTitle: "Dirección y acceso",
            adresse: [
                "La clínica se encuentra en una calle tranquila de Asnières-sur-Seine, accesible en transporte público y en coche. Prevé unos minutos para aparcar en horas punta.",
                "Te pedimos que llegues unos minutos antes de la hora de tu cita, con tus últimos análisis de sangre y la lista de tus tratamientos si los tienes.",
            ],
            zoneTitle: "Quién viene a la clínica",
            zoneLead:
                "Las pacientes vienen de Asnières-sur-Seine y de los municipios vecinos de Hauts-de-Seine, así como del noroeste de París:",
            quartiers: [
                "Asnières-sur-Seine",
                "Clichy",
                "Bois-Colombes",
                "Courbevoie",
                "Levallois-Perret",
                "Gennevilliers",
                "Colombes",
                "París 17",
            ],
            faqTitle: "Preguntas frecuentes sobre la clínica",
            faq: [
                [
                    "¿Cómo es una primera cita en la clínica?",
                    "Empieza por una consulta: entrevista sobre tu historia y tus signos, y después exploración clínica de la piel, el cabello y el vello. Puede prescribirse un estudio. En esa primera cita no se realiza ningún acto estético.",
                ],
                [
                    "¿Qué debo traer?",
                    "Tus últimos análisis de sangre si los tienes, la lista de tus tratamientos actuales, anticoncepción incluida, y tus preguntas. Para un tratamiento facial, ven sin maquillaje.",
                ],
                [
                    "¿Puedo venir acompañada?",
                    "Sí. La recepción permite que la persona que te acompaña espere en la clínica durante la consulta o el tratamiento.",
                ],
                [
                    "¿Se llega fácilmente desde los municipios vecinos?",
                    "La clínica está en 10 rue Vladimir Kramnik, en una calle tranquila de Asnières-sur-Seine. También vienen pacientes de Clichy, Bois-Colombes, Courbevoie, Levallois-Perret, Gennevilliers, Colombes y del distrito 17 de París.",
                ],
                [
                    "¿Cuáles son los días y el horario de apertura?",
                    "La clínica atiende con cita previa lunes, martes, jueves y viernes, de 10:30 a 17:30. Cierra miércoles, sábado y domingo. Los huecos realmente disponibles son los que aparecen en Doctolib, que se actualiza en tiempo real.",
                ],
                [
                    "¿Cómo pido cita?",
                    "La cita se pide únicamente en línea, a través de Doctolib. Allí eliges el motivo — consulta de medicina estética, salud de la mujer, depilación láser — y después el hueco que te convenga. Recibes una confirmación y un recordatorio automáticos, y puedes anular o cambiar la cita desde el mismo espacio.",
                ],
                [
                    "¿Las consultas y los tratamientos están cubiertos?",
                    "Los actos de medicina estética no están cubiertos por la seguridad social francesa. Las tarifas se comunican de antemano y se detallan en la página de tarifas; para cualquier acto estético se entrega un presupuesto por escrito antes de realizarlo.",
                ],
                [
                    "¿Hay que venir varias veces para un mismo tratamiento?",
                    "Depende del tratamiento. Algunos gestos se hacen en una sesión; otros — depilación láser, electrólisis, melasma, caída del cabello, calidad de la piel — requieren varias sesiones espaciadas y después mantenimiento. El número de sesiones previsto se te indica en consulta, antes de cualquier decisión.",
                ],
            ],
            moreBefore: "Para saber más: la página de",
            moreTarifs: "tarifas",
            moreMiddle:
                "detalla el precio de cada consulta y de cada tratamiento realizado en la clínica, y la página de",
            moreMedecin: "la doctora",
            moreAfter: "presenta la trayectoria y los títulos de la Dra. Souhali Massilia.",
        },
        soin: {
            faqTitle: "Preguntas frecuentes",
            ctaTitle: "Pedir cita",
            ctaText: `Consulta en la clínica, ${SITE.address}. Para una primera cita, elige «primera consulta».`,
            relatedTitle: "También te puede interesar",
            disclaimer:
                "La información de esta página tiene carácter general y no sustituye una consulta médica. Los resultados varían de una persona a otra. Para los actos estéticos se entrega un presupuesto por escrito y se respeta un plazo de reflexión.",
        },
        notfound: {
            eyebrow: "Error 404",
            h1: "Esta página no existe",
            lead: "Puede que el enlace que has seguido esté incompleto. Esto es lo que puedes visitar:",
            homeLink: "Volver al inicio",
        },
    },
    error: {
        h1: "Se ha producido un error",
        text: "La página no ha podido mostrarse correctamente. Recárgala o vuelve al inicio.",
        reload: "Recargar la página",
        home: "Volver al inicio",
    },
    seo: {
        home: {
            title: "Medicina estética en Asnières-sur-Seine — Aurassium Clinic",
            description:
                "Dra. Souhali Massilia, médica de medicina estética, antiedad y salud de la mujer en Asnières-sur-Seine, cerca de París: depilación láser y electrólisis, ácido hialurónico, skinboosters, peelings, microneedling, SOP y menopausia.",
        },
        tarifs: {
            title: "Tarifas — consultas, tratamientos y depilación láser",
            description:
                "Tarifas 2026 de la consulta de la Dra. Souhali Massilia en Asnières-sur-Seine: consulta, SOP, peelings, microneedling, skinbooster, ácido hialurónico, depilación láser por zona.",
        },
        medecin: {
            title: "Dra. Souhali Massilia, médica en Asnières-sur-Seine",
            description:
                "Dra. Souhali Massilia, médica fundadora de Aurassium Clinic en Asnières-sur-Seine: medicina estética, antiedad y salud de la mujer. Títulos, formación y n.º RPPS.",
        },
        cabinet: {
            title: "La clínica en Asnières-sur-Seine — acceso y fotos",
            description:
                "Aurassium Clinic, 10 rue Vladimir Kramnik en Asnières-sur-Seine: fotos, acceso, zonas atendidas y cita en línea.",
        },
        conseils: {
            title: "Consejos antes y después de un tratamiento — Aurassium Clinic",
            description:
                "Cómo preparar una sesión de depilación láser, un peeling, un microneedling o unas inyecciones, y qué hacer después: precauciones, fotoprotección y señales para volver a contactar.",
        },
        notfound: {
            title: "Página no encontrada — Aurassium Clinic",
            description: "Esta página no existe o ya no existe.",
        },
    },
};

export default es;
